import * as SubNav from './index';
import { IntercomProductTourTargets } from 'constants/intercom';
import { TestIds } from 'constants/tests';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const TransactionsSubNavTabs = () => {
    const { accountId } = useCurrentAccount();

    return (
        <SubNav.Tabs>
            <SubNav.TabItem to={`/accounts/${accountId}/transactions`}>
                All Transactions
            </SubNav.TabItem>
            <SubNav.TabItem
                to={`/accounts/${accountId}/tickets`}
                data-testid={TestIds.Transactions.Tickets}
            >
                Tickets
            </SubNav.TabItem>
            <SubNav.TabItem
                to={`/accounts/${accountId}/plans`}
                data-intercom-target={
                    IntercomProductTourTargets.TransactionsRecurringPlansSubnavTab
                }
                data-testid={TestIds.Transactions.Plans}
            >
                Recurring plans
            </SubNav.TabItem>
            <SubNav.TabItem
                to={`/accounts/${accountId}/pledges`}
                data-intercom-target={IntercomProductTourTargets.TransactionsPledgesSubnavTab}
                data-testid={TestIds.Transactions.Pledges}
            >
                Pledges
            </SubNav.TabItem>
        </SubNav.Tabs>
    );
};
export { TransactionsSubNavTabs };
